import { render, staticRenderFns } from "./resultatsFolderTreeViewComponent.vue?vue&type=template&id=27aa61b9&"
import script from "./resultatsFolderTreeViewComponent.vue?vue&type=script&lang=js&"
export * from "./resultatsFolderTreeViewComponent.vue?vue&type=script&lang=js&"
import style0 from "./resultatsFolderTreeViewComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports